import { Text } from "@chakra-ui/react"
import * as gqlTypes from "@hydrologiq/gql-experience/graphql"
import { roundToDP } from "@hydrologiq/common/helpers/math"

interface CustomerSiteHydrogenProps {
  site: gqlTypes.CustomerSite
}

function CustomerSiteHydrogen({ site }: CustomerSiteHydrogenProps) {
  const hydrogenOnSiteKg = site.hydrogenOnSiteKg

  if (!hydrogenOnSiteKg || hydrogenOnSiteKg === 0) {
    return <Text color="gray.500">0 kg</Text>
  }

  return <Text fontWeight="medium">{roundToDP(hydrogenOnSiteKg, 2)}</Text>
}

export default CustomerSiteHydrogen
